/**
 * @desc 批量解绑SN
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierSn/batchUnBind`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
